export default __webpack_public_path__ + "img/b89b53d9d31e5c6626c5a85670d2f0f9.svg";